import { Label, Input } from "./Filter.styled.js";

export const Filter = ({ value, onChange }) => {
  return (
    <div>
      <Label>Find contacts by name</Label>
      <Input type="text" value={value} onChange={onChange} />
    </div>
  );
};
